import { privateRequest } from "../apiConfig/privateRequest"


export const dashboardCountData =async(url,payload) => {
    const result = await privateRequest.get(`https://cvmaker.nimapinfotech.com/api${url}`) 
    return result
}